import React, { Component } from "react"
import * as dateHelper from "../../booking/helpers/date"
import * as htmlHelper from "../../helpers/html"
import StylishTable from "../../styleguide/js/components/stylish-table"

class FlightSearchResult extends Component {
  constructor(props) {
    super(props)
    this.tableRef = React.createRef()
  }
  componentDidMount() {
    if (this.tableRef.current) {
      new StylishTable({ el: this.tableRef.current })
    }
  }

  renderTableHeaders() {
    const { config, activeTab } = this.props
    return (
      <React.Fragment>
        <div className="stylish-table__cell travelguide-flights__table__col--destination">
          <div>
            <span>{(activeTab === 1 ? config.flightTableDepartureDestinationText : config.flightTableArrivalDestinationText) || "Destination"}</span>
          </div>
        </div>
        <div className="stylish-table__cell travelguide-flights__table__col--time">
          <div>
            <span>{config.flightTableTimeText || "Tid"}</span>
          </div>
        </div>
        <div className="stylish-table__cell travelguide-flights__table__col--carrier ">
          <div>
            <span>
              <span>{config.flightTableAirlineText || "Operatør"}</span>
            </span>
          </div>
        </div>
        <div className="stylish-table__cell travelguide-flights__table__col--carrier v--desktop-only">
          <div>&nbsp;</div>
        </div>
      </React.Fragment>
    )
  }

  renderFlight(flight, index) {
    const { config } = this.props
    // const time = isMobile ? dateHelper.formatDate(flight.ScheduledTime, 'HH:mm', 'da') :dateHelper.formatDate(flight.ScheduledTime, 'DD / MM / YYYY  HH:mm', 'da')
    const time = dateHelper.formatDate(flight.ScheduledTime, "HH:mm", "da")
    const isChosen = this.props.chosenFlightId === flight.RecordId
    const rowBgStyle = isChosen ? { backgroundColor: "#eff1f2" } : {}
    const colStyle = isChosen ? { borderRight: 0 } : {}
    return (
      <div
        key={index}
        className={`stylish-table__row stylish-table__row--body pointer ${
          !this.props.chosenFlightId || (this.props.chosenFlightId && isChosen) ? `` : `hide`
        } `}
        style={rowBgStyle}
        onClick={() => this.props.buttonClickHandler(flight.RecordId)}
      >
        <div className="stylish-table__cell travelguide-flights__table__col--destination" style={colStyle}>
          <div>
            <span>
              <strong>
                <span>{flight.DestinationName}</span>
              </strong>
            </span>
            <span>
              <small>{flight.Flight}</small>
            </span>
          </div>
        </div>
        <div className="stylish-table__cell travelguide-flights__table__col--time" style={colStyle}>
          <div>
            <span>
              <em>{time}</em>
            </span>
          </div>
        </div>
        <div className="stylish-table__cell travelguide-flights__table__col--carrier">
          <div>
            <span>
              <span>{flight.CarrierName}</span>
            </span>
          </div>
          <div className="v--mobile-only">
            <span>
              <button
                className={`button button--small no-shadow ${isChosen ? `button--general` : config.flightTableChooseButtonBackgroundColor}`}
                onClick={() => this.props.buttonClickHandler(flight.RecordId)}
              >
                {isChosen ? config.flightTableChosenText || "Valgt" : config.flightTableChooseText || "Vælg"}
              </button>
            </span>
          </div>
        </div>
        <div className="stylish-table__cell v--desktop-only">
          <div>
            <span>
              <button
                className={`button button--small no-shadow ${isChosen ? `button--general` : config.flightTableChooseButtonBackgroundColor}`}
                onClick={() => this.props.buttonClickHandler(flight.RecordId)}
              >
                {isChosen ? config.flightTableChosenText || "Valgt" : config.flightTableChooseText || "Vælg"}
              </button>
            </span>
          </div>
        </div>
      </div>
    )
  }

  render() {
    const { flights, query, config } = this.props

    if (query === "" && (!flights || flights.length === 0)) return null

    return (
      <React.Fragment>
        <div className="travelguide-flights__table stylish-table js--stylish-table" ref={this.tableRef}>
          <div className="stylish-table__row stylish-table__row--head is-grey">{this.renderTableHeaders()}</div>
          {flights.map((flight, index) => this.renderFlight(flight, index))}
        </div>

        {flights.length === 0 && (
          <div className="flights__no-results">
            <div className="section-header section-header--small">
              <div>
                {(config.flightNoResult && htmlHelper.htmlStringToReactElement(config.flightNoResult)) || (
                  <React.Fragment>
                    <h2>Der er ikke noget information om den valgte dato eller afgang</h2>
                    <p>Tjek om du har stavet rigtigt eller valgt den korrekte dato</p>
                  </React.Fragment>
                )}
              </div>
            </div>
          </div>
        )}
      </React.Fragment>
    )
  }
}
export default FlightSearchResult
